import { FiltersNumberMethod } from '../../utilities/filters.number.utility';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';
import { Entity } from '../entity';
import { SaleOrderStatus } from './sale.order';
import * as Enumerable from 'linq';

export interface SaleOrderViewLookups {

    account?: Entity[];
    owner?: Entity[];
    company?: Entity[];
    billingCompany?: Entity[];
    status?: SaleOrderStatus[];
    createdBy?: Entity[];
}

export interface SaleOrderViewFilters extends SaleOrderViewLookups {
    _id?: string;
    search?: string;

    totalSellEx?: FiltersNumberMethod;
    date?: FiltersRelativeDateMethod;
    expiryDate?: FiltersRelativeDateMethod;
    createdAt?: FiltersRelativeDateMethod;
}

class SaleOrderViewFiltersClass implements Required<SaleOrderViewFilters> {
    _id = null

    // Multi - Need to check data inside
    search: string = null;
    prepaymentOnly: boolean = false;

    account: Entity[] = [];
    status: SaleOrderStatus[] = [];
    owner: Entity[] = [];
    company: Entity[] = [];
    billingCompany: Entity[] = [];
    createdBy: Entity[];

    totalSellEx: FiltersNumberMethod = null;
    date: FiltersRelativeDateMethod = null;
    expiryDate: FiltersRelativeDateMethod = null;
    createdAt: FiltersRelativeDateMethod = null;
}

export function effectiveSaleOrderViewFilters(view: SaleOrderViewFilters, refinements: SaleOrderViewFilters) {

    const effective: { [k in keyof SaleOrderViewFilters] } = {} as SaleOrderViewFilters;
    const keys = Object.keys(new SaleOrderViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : view[key];
            }

            if (effective[key] == null ||
                (typeof effective[key] !== 'boolean' && Object.keys(effective[key])?.length == 0)
            ) {
                delete effective[key];
            }
        });

    return effective;

}
